export const GooglePlayIconSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="25" viewBox="0 0 29 25" fill="none">
      <g filter="url(#filter0_d_13_3)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.39794 0.341171C4.14569 0.614106 4 1.03115 4 1.57702V20.9379C4 21.4838 4.14569 21.9008 4.40664 22.1629L4.47405 22.2218L15.2771 11.3743V11.1319L4.46535 0.282217L4.39794 0.341171Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.39794 0.341171C4.14569 0.614106 4 1.03115 4 1.57702V20.9379C4 21.4838 4.14569 21.9008 4.40664 22.1629L4.47405 22.2218L15.2771 11.3743V11.1319L4.46535 0.282217L4.39794 0.341171Z"
          fill="#857373"
          fillOpacity="0.2"
        />
        <g opacity="0.4">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.8714 15.001L15.2682 11.383V11.1297L18.8714 7.51166L18.9497 7.5597L23.2118 9.99209C24.4317 10.6821 24.4317 11.8218 23.2118 12.5206L18.9497 14.953L18.8714 15.001Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.8714 15.001L15.2682 11.383V11.1297L18.8714 7.51166L18.9497 7.5597L23.2118 9.99209C24.4317 10.6821 24.4317 11.8218 23.2118 12.5206L18.9497 14.953L18.8714 15.001Z"
            fill="#857373"
            fillOpacity="0.2"
          />
        </g>
        <g opacity="0.7">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9497 14.9531L15.2683 11.2564L4.39783 22.1717C4.79576 22.5996 5.46334 22.6477 6.2092 22.2306L18.9497 14.9531Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9497 14.9531L15.2683 11.2564L4.39783 22.1717C4.79576 22.5996 5.46334 22.6477 6.2092 22.2306L18.9497 14.9531Z"
            fill="#857373"
            fillOpacity="0.2"
          />
        </g>
        <g opacity="0.2">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9497 7.55963L6.2092 0.293012C5.46334 -0.13495 4.79359 -0.0759954 4.39783 0.351966L15.2683 11.2563L18.9497 7.55963Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9497 7.55963L6.2092 0.293012C5.46334 -0.13495 4.79359 -0.0759954 4.39783 0.351966L15.2683 11.2563L18.9497 7.55963Z"
            fill="#857373"
            fillOpacity="0.2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_13_3"
          x="0"
          y="0"
          width="28.1267"
          height="30.5193"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_3" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_3" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
